import { Content } from '../models/content';

export const germanContent: Content = {
  translation: {
    title:
      'Cardano Staking Pool Operator mit Sitz in Europa<br /> entworfen und gebaut von <a href="mailto:adapool_charles@pm.me">@Charles</a> und <a href="mailto:adapool_mikael@pm.me">@Mika</a>.',
    whoAreWe: 'Wer sind wir?',
    whyJoinUs: 'Warum uns beitreten?',
    poolDetails: 'Pool-Details',
    s1: {
      p1: 'Wir sind Charles 😊 und Mika 😉, eine Partnerschaft zweier französischer Unternehmer, die motiviert sind, die Nutzung von Kryptowährungen zu demokratisieren.',
      p2: 'Mika, der Verwaltungen bei ihrer digitalen Transformation unterstützt, bringt seine technische und menschliche Erfahrung ein. Charles bringt über ein Jahrzehnt Erfahrung in der Softwaretechnik mit. Gemeinsam beteiligen wir uns mit Begeisterung an der Entwicklung des Cardano-Netzwerks!',
      p3: 'Wir beschäftigen uns seit 2017 mit Kryptowährungen, als wir die Chance hatten, an der Spitze des Marktes Gewinne zu erzielen. In diesem Moment entdeckten wir das Cardano-Projekt und verfolgen es seither mit großem Interesse. Unser Ziel mit ADA Pool Europe ist es, eine Gemeinschaft von Menschen zu schaffen, die unsere Werte teilen, an Cardano glauben und denen wir eine gute Erfahrung bei der Kapitalbündelung bieten möchten.',
      p4: 'Unser Ziel mit ADA Pool Europe ist es, eine Gemeinschaft von Menschen zu schaffen, die unsere Werte teilen, an Cardano glauben und denen wir eine gute Erfahrung bei der Kapitalbündelung bieten.',
    },
    s2: {
      p1: 'Wir sind motiviert, die Nutzung von Kryptowährungen zu demokratisieren.',
      p2: ' Hochverfügbarkeits-Infrastruktur',
      p3: ' mit begrenzten Gebühren',
      p4: ' offen für das größtmögliche Publikum',
      p5: ' dedizierte und sichere Server',
      p6: 'Unser in Europa ansässiger Cardano-Staking-Pool widmet sich der Stärkung und Dezentralisierung des Cardano-Netzwerks. \n Wir bieten hochverfügbares, zuverlässiges und sicheres Staking, basierend auf zwei Relay-Knoten und einem Producer-Knoten in Serverzentren der Enterprise-Klasse. Unser Ziel ist es, eine gute Erfahrung für die Teilnehmer zu schaffen.',
      p7: 'Wir legen großen Wert auf die Leistung und Sicherheit unserer Pool-Infrastruktur. Wir möchten so vielen Menschen wie möglich die Teilnahme am Krypto-Abenteuer ermöglichen.',
      p8: 'Indem Sie Ihre ADAs in unserem Pool staken, beteiligen Sie sich am Betrieb des Cardano-Netzwerks.',
      p9: "✔&nbsp;Ihre ADAs sind nie blockiert, Sie können sie jederzeit und ohne Strafe übertragen&nbsp;;<br><br> ✔&nbsp;Ihre ADAs befinden sich immer in Ihrer Wallet, sie bleiben bei Ihnen. Sie können sie durch die 'Staking'-Methode nicht verlieren&nbsp;;<br><br> ✔&nbsp;Ihre Belohnungen werden automatisch reinvestiert. Alle 5 Tage erhalten Sie Ihren Anteil an den Gewinnen, die automatisch gestackt werden&nbsp;;<br><br> ✔&nbsp;Sie können mit dem Stacken Ihrer ADA beginnen, auch wenn Sie nur sehr wenige haben.",
    },
    s3: {
      p1: 'Die Teilnahme am Cardano-Netzwerk ist einfach!<br>Sie müssen nur Ihre ADA-Kryptowährungen in unserem "adapool-europe"-Pool staken.',
      p2: 'Die Kennung, die Sie eingeben müssen, um Ihre ADA zu delegieren:',
      p3: 'Interaktives Widget',
      p4: 'Pledge',
      p5: 'Besitzer:',
      p6: 'Wert:',
      p7: ' Stake',
      p8: 'Delegatoren:',
      p9: 'Wert:',
      p10: 'Gebühren',
      p11: 'Variable Gebühren:',
      p12: 'Feste Gebühr:',
      p13: 'Kryptowährungspreis',
    },
    footer: {
      p1: 'Kontaktieren Sie uns',
    },
  },
};
